import React, { FC } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import CustomAccordion from "components/CustomAccordion";

const NfcSection: FC = () => {
  return (
    <>
      <Typography component="h2" variant="h2" my={4}>
        NFC
      </Typography>
      <CustomAccordion title="What is a Uniqly Tag?">
        <Box width="100%">
          <Typography>
            A small, elegant NFC tag you can attach to any physical product —
            from apparel and sneakers to gadgets and collectibles. When scanned
            with a phone, it opens a custom branded web page — your new
            marketing channel.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="What can I put on the tag?">
        <Box width="100%">
          <Typography mb={2}>
            Your tag can link to a fully customizable page where you can
            include:
          </Typography>
          <Typography component="div">
            <ul>
              <li>
                Links (website, TikTok, Spotify, Instagram, campaign pages)
              </li>
              <li>Embedded videos or trailers</li>
              <li>Signup or feedback forms</li>
              <li>Graphics, descriptions, and call-to-actions</li>
              <li>Claimable rewards (discounts, giveaways, loyalty perks)</li>
            </ul>
          </Typography>
          <Typography>
            You control the experience. Think of it as a landing page directly
            attached to your product.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="Why is the Uniqly Tag a new marketing channel?">
        <Box width="100%">
          <Typography>
            It stays with your customer on the product, lets you update content
            anytime, and creates a direct, trackable link between your physical
            item and digital experience — perfect for loyalty, re-engagement,
            and storytelling.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="Is this suitable for limited editions or drops?">
        <Box width="100%">
          <Typography>
            Perfectly. Tags can add exclusivity, track authenticity, or offer
            unlockable perks for early buyers. Great for hype-driven drops or
            VIP campaigns.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="What if I want to change the campaign later?">
        <Box width="100%">
          <Typography>
            No problem. You can update the content behind each tag at any time,
            even after the product is in your customer's hands.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="Do I need to run a full campaign with you?">
        <Box width="100%">
          <Typography mb={2}>
            No! You can choose from flexible options:
          </Typography>
          <Typography component="div" mb={2}>
            <strong>Order just the NFC tags (custom branded)</strong>
          </Typography>
          <Typography component="div" mb={2}>
            <strong>Add-on services like:</strong>
            <ul>
              <li>Attaching to your merch</li>
              <li>3D model of your product</li>
              <li>Custom landing page</li>
            </ul>
          </Typography>
          <Typography component="div">
            <strong>Or go all-in with full support:</strong>
            <ul>
              <li>Product design</li>
              <li>Logistics</li>
              <li>Digital gamification</li>
            </ul>
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="What brands or companies have collaborated with Uniqly?">
        <Box width="100%">
          <Typography>
            Uniqly has proudly collaborated with brands and communities such as
            Puma, Adidas, Clout Festival, ETH Warsaw, Rug Radio, Rektguy, and
            Widzew Łódź, among others.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="How can I partner with Uniqly for a campaign, drop, or live event?">
        <Box width="100%">
          <Typography>
            If you're interested in launching a campaign, activation, or
            exclusive drop with Uniqly, reach out to our team at
            contact@uniqly.io and we'll get back to you shortly.
          </Typography>
        </Box>
      </CustomAccordion>
      <CustomAccordion title="Can I create a full Phygital product on my own?">
        <Box width="100%">
          <Typography>
            Not yet. At the moment, Uniqly does not offer a fully self-service
            platform for independent phygital creation. We handle the process in
            collaboration with partners and brands.
          </Typography>
        </Box>
      </CustomAccordion>
    </>
  );
};

export default NfcSection;
